import { AppRouteURI } from "router/RoleBasedAccess"
import { useState, useEffect } from "react"
import { Redirect } from "react-router-dom"
import React from "react"
// import { VERIFY_EMAIL } from "api/AuthConstants"
import { useSelector } from "react-redux"
import authActions from "components/Auth/actions"
import {
    Grid, Card, Typography
} from "@material-ui/core";
import useStyles from "../ResendVerification/Styles"

export const VerifyEmail = () => {
    const [verifiedStatus, setVerifiedStatus] = useState()
    const { verifyEmail } = authActions()
    const {busy} = useSelector(state => state.app)
    const { verified } = useSelector(state => state.auth)
    const classes = useStyles();

    const componentMount = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        verifyEmail(token)
    }
    useEffect(componentMount, [])

    useEffect(() => {
        setVerifiedStatus(verified)
    }, [verified])

    return <>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                className={classes.rootGrid}
            >
                <Grid item xs='auto' md="auto">
                    <Card variant="outlined" className={classes.card}>
                        <Typography align="center" variant="h4" component="h2" className={classes.title}  >
                            { busy ? "Verifying ..." :
                                verifiedStatus === undefined ?
                                    "Verifying ..." :
                                        verifiedStatus ?
                                        <Redirect to={`${AppRouteURI.LOGIN}?verified=true`} /> : "Verification Failed"
                            }
                        </Typography>
                        <Typography variant="subtitle2" component="h2" className={classes.subtitle} >
                        {busy ? "" :
                                verifiedStatus === undefined ?
                                    "" : verifiedStatus 
                                    ?
                                       ""
                                    : 
                            `The verification link is invalid or has expired. Please try again`
                        }
                        </Typography>
                    </Card>
                </Grid>      
            </Grid>
        </>
}